import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { default as qs } from 'qs';

const initialState: RoleState = {
  all: [],
  viewing: undefined,
};

const getters: GetterTree<RoleState, RootState> = {
  all(state: RoleState): Role[] {
    return state.all;
  },
};

const mutations: MutationTree<RoleState> = {
  RESET(state: RoleState) {
    state.all = [];
    state.viewing = undefined;
  },
  UPDATE_MODEL(state: RoleState, payload: Role) {
    const index = state.all.findIndex((model: Role) => model.id === payload.id);

    if (index === -1) {
      state.all.push(payload);
    } else {
      state.all[index] = payload;
    }
  },
  SET_MODELS(state: RoleState, payload: Role[]) {
    state.all = payload;
  },
  SET_VIEWING(state: RoleState, payload: Role) {
    state.viewing = payload;
  },
};

const actions: ActionTree<RoleState, RootState> = {
  index({ commit, rootState }, payload: { query?: IndexQuery<Role>; workspaceId: number }) {
    const queryString = qs.stringify(payload?.query, { encode: false });

    return rootState.api
      .get(`api/roles?${queryString}`, { withCredentials: true, headers: { common: { 'x-workspace-id': payload.workspaceId } } })
      .then((response: { data: Role }) => {
        commit('SET_MODELS', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  read({ commit, rootState }, payload: { id: number; workspaceId: number }) {
    return rootState.api
      .get(`api/roles/${payload.id}`, { withCredentials: true, headers: { common: { 'x-workspace-id': payload.workspaceId } } })
      .then((response: { data: Role }) => {
        commit('UPDATE_MODEL', response.data);

        commit('SET_VIEWING', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
